export const normalizeString = (value) => {
  const string = value + "";

  return string
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};
